'use client'

import { useState } from 'react'

import { useTranslations } from '@/lib/next-shim'

import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'

import { PasswordChangeOtpDialog } from './PasswordChangeOtpDialog'

export function SecuritySection() {
  const t = useTranslations()
  const [otpOpen, setOtpOpen] = useState(false)

  return (
    <Paper elevation={0} sx={{ borderRadius: 3, p: 4, boxShadow: '0 12px 40px rgba(25,28,29,0.06)' }}>
      <Stack spacing={3}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <LockOutlinedIcon sx={{ color: 'primary.dark' }} />
          <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '-0.01em' }}>
            {t('page.AccountSettings.profile.security.title')}
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {t('page.AccountSettings.profile.security.description')}
        </Typography>
        <Box>
          <Button
            type="button"
            variant="outlined"
            startIcon={<LockOutlinedIcon />}
            onClick={() => setOtpOpen(true)}
            disabled={otpOpen}
            sx={{
              color: 'primary.main',
              borderColor: 'primary.main',
              fontWeight: 600,
              borderRadius: 2,
              '&:hover': { borderColor: 'primary.dark', color: 'primary.dark', bgcolor: 'transparent' },
            }}
          >
            {t('page.AccountSettings.profile.security.changePasswordButton')}
          </Button>
        </Box>
      </Stack>
      <PasswordChangeOtpDialog
        open={otpOpen}
        onClose={() => setOtpOpen(false)}
        onConfirmed={() => {
          setOtpOpen(false)
        }}
      />
    </Paper>
  )
}
